import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cinta-superior',
  templateUrl: './cinta-superior.component.html',
  styleUrls: ['./cinta-superior.component.css']
})
export class CintaSuperiorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  mostrarAlerta(nombre: string, url: string, target: string) {
    Swal.fire({
      title: 'Redireccionamiento',
      text: "Usted está a punto de ingresar a un sitio externo de la sede electrónica del SENA. "
            +"A partir de este momento es responsabilidad de "+nombre+" el cumplimiento de las normas que regulan su relación. "
            +"Cualquier solicitud deberá ser dirigida al responsable de dicho sitio "+nombre+". ¿Desea ingresar al sitio?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#E56000',
      cancelButtonColor: '#E56000',
      cancelButtonText: 'No',
      confirmButtonText: 'Si'
    }).then((result) => {
      if (result.isConfirmed) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = target
        anchor.click();
      }
    });
  }

}
